/**
 * Used in related video preloader
 */
import { Box, Skeleton } from "@mui/material"

export const SkeletonVideoList = () => {
    return (
        <>
            {[1, 2, 3].map((item) => (
                <Box
                    key={item}
                    display="flex"
                    alignItems="flex-start"
                    gap={2}
                    pt={2}
                    flexWrap={{ xs: 'wrap', sm: 'nowrap' }}
                    width="100%"
                >
                    {/* Thumbnail */}
                    <Skeleton
                        variant="rectangular"
                        sx={{
                            width: { xs: 120, sm: 180 },
                            height: { xs: 80, sm: 110 },
                            borderRadius: "12px",
                            flexShrink: 0
                        }}
                    />

                    {/* Text Content */}
                    <Box flex={1} minWidth={0} display="flex" flexDirection="column" justifyContent="center">
                        <Box display="flex" justifyContent="space-between" alignItems="center" minWidth={0}>
                            <Skeleton variant="text" width="80%" height={24} />
                            <Skeleton variant="circular" width={24} height={24} sx={{ ml: 1 }} />
                        </Box>
                        <Skeleton variant="text" width="30%" height={24} />
                        <Skeleton
                            variant="rectangular"
                            width={55}
                            height={25}
                            sx={{
                                borderRadius: 24,
                                mt: 2
                            }}
                        />
                    </Box>
                </Box>
            ))}
        </>
    )
}